module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Wall</h1>\n</div>\n<iframe src=\"apps/wall/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/wall/wall.component.html
// module id = ../../../../../src/app/pages/wall/wall.component.html
// module chunks = main